export default __webpack_public_path__ + "static/media/gallery-wip-motor-housing-assembly_03.e246dbf5.jpg";